import _get from 'lodash/get';
import useIsAdmin from 'helpers/useIsAdmin';

/**
 * Social photos are editable when `socialPhotos.enabled` is true (default).
 * When it is false, only admins can edit if `socialPhotos.allowAdminEditing` is true.
 */
export function getSocialPhotosEditable(root: any, isAdmin: boolean): boolean {
  const socialPhotosSettings = _get(root, ['_directorySettings', 'socialPhotos']);
  const enabled = _get(socialPhotosSettings, ['enabled'], true);
  const allowAdminEditing = _get(socialPhotosSettings, ['allowAdminEditing'], false);

  return enabled || (allowAdminEditing === true && isAdmin);
}

export default function useSocialPhotosEditable(root: any): boolean {
  const isAdmin = useIsAdmin() as boolean;
  return getSocialPhotosEditable(root, isAdmin);
}
